define.alias("shared/modifiers/wheel-pan", "settings/modifiers/wheel-pan");